class PasswordModal extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.modal = this.querySelector('.modal__content');
    this.closeButton = this.querySelector('.modal__close-button');
    
    this.setupEventListeners();
    
    if (this.querySelector('input[aria-invalid="true"]')) {
      this.open();
    }
  }

  setupEventListeners() {
    if (!this.details || !this.summary) return;

    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }
    
    document.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (this.details.open) {
      this.close();
    } else {
      this.open();
    }
  }

  onKeyDown(event) {
    if (event.key === 'Escape' && this.details.open) {
      this.close();
    }
  }

  open() {
    this.details.open = true;
    document.body.style.overflow = 'hidden';
    
    const input = this.querySelector('input[type="password"]');
    if (input) {
      setTimeout(() => input.focus(), 100);
    }
  }

  close() {
    this.details.open = false;
    document.body.style.overflow = '';
    this.summary?.focus();
  }
}

customElements.define('password-modal', PasswordModal);
